/**
 * Tools API
 *
 * Thin wrappers around server endpoints for AI copy analysis and acquiring
 * pre-signed video upload URLs. Uses core request helpers with appropriate
 * timeouts where needed.
 */
import { get, post } from '../core';

/**
 * Analyzes copy content using the copyAnalyzer service  
 * @param {Object} copyData - The copy data to analyze
 * @returns {Promise<Object>} - Promise resolving to analysis results
 */
export function analyzeCopy(copyData) {
  // Add a 45-second timeout for AI operations
  console.log('analyzeCopy: Setting timeout to 45 seconds for AI operation');
  return post('/copyAnalyzer/analyze', copyData, {
    timeout: 45000 // 45 seconds
  });
}

/**
 * Gets a video upload URL from the server
 * @returns {Promise<{uploadUrl: string, permanentUploadPath: string}>} Upload URL and permanent path
 */
export function getVideoUploadUrl() {
  return get('/templateManagement/video/video-upload-url');
}

export default {
  analyzeCopy,
  getVideoUploadUrl
}; 